export default __webpack_public_path__ + "static/media/app-top-items.652b89bb.png";